export const CODE_TYPES = {
    SUBSCRIPTION:           0,
    INVITATION_CARD:        1,
    STANDARD_INVITATION:    2,
    NFC_CARD:               3,
};